<template>
  <q-dialog v-model="dialog" persistent class="order-quotation-dialog order-confirm-dialog">
    <q-card>
      <q-toolbar class="information">
        <q-avatar>
          <q-icon name="mdi-alert-circle" />
        </q-avatar>
        <q-toolbar-title class="text-weight-bold">
          注文時にご確認くださいますようお願いいたします
        </q-toolbar-title>
      </q-toolbar>
      <q-card-section>
        <ul class="dialog-textarea">
          <li>納期は目安として設定しております。状況により多少前後する場合がございます。</li>
          <li>注文後内容に変更が発生した際は、随時ご連絡いたします。</li>
          <li>15 時以降のご注文は翌営業日のお手配となります。</li>
          <li>ご注文合計金額は確定メールにてご確認をお願いいたします。</li>
          <li>お届け先、お電話番号等に変更がございましたら、速やかにご連絡をお願いいたします。</li>
        </ul>
        <p></p>
        <span class="text-weight-bold" style="font-size: 16px">以下について、ご留意ください</span>
        <p class="q-mb-none" style="margin-left: 21px">
          ※法規制化学物質チェックを行うので処理に時間がかかる可能性があります。
        </p>
        <p class="q-mb-none" style="margin-left: 21px">
          ※「毒物」、「劇物」のうち、新たに登録を行う場合は、納品までに3～4週間を要する場合があります。
        </p>
        <p class="q-mb-none" style="margin-left: 21px">
          ※国連番号に応じた輸送を行うため、別途危険品輸送料などが発生する場合があります。
        </p>
        <p class="q-mb-sm" style="margin-left: 21px">
          ※中国サプライヤの安定同位体を含む製品は、お取り扱いできません。
        </p>
      </q-card-section>
      <q-card-actions align="center" class="btn-area q-gutter-md">
        <q-btn color="primary" label="注文依頼を確定する" style="width: 200px" @click="ok" />
        <q-btn
          outline
          label="キャンセル"
          style="color: var(--q-delete); width: 180px"
          @click="cancel"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  // ダイアログを表示するかどうか
  display: boolean;
}

const props = defineProps<Props>();
const dialog = computed(() => props.display);

const emit = defineEmits<{
  (event: 'ok'): void;
  (event: 'cancel'): void;
}>();

const ok = () => {
  emit('ok');
};

const cancel = () => {
  emit('cancel');
};
</script>
<style scoped>
.order-confirm-dialog .q-card {
  min-width: 400px;
  padding: 15px 30px;
}
.order-confirm-dialog .q-toolbar .q-avatar {
  font-size: 36px;
}

.order-confirm-dialog .q-toolbar.information .q-icon {
  color: var(--q-info);
  font-size: 34px;
}

.order-confirm-dialog .q-toolbar .q-toolbar__title {
  font-size: 22px;
  padding-top: 4px;
  line-height: 36px;
  padding-left: 14px;
}
</style>
